import React from 'react'
import BuyerQuoteDashboard from '../../../components/BuyerQuoteDashboard'
import VendorQuoteDashboard from '../../../components/VendorQuoteDashboard'

interface GovQuoteDashboardProps {
  userRole: 'ENTERPRISE_VENDOR' | 'AGENCY' | 'ADMIN' | 'GOV_EMAIL'
  quotes: any[]
  loading: boolean
  onQuoteAction: (action: string, quoteId: string) => void
  hideHeader?: boolean
}

export const GovQuoteDashboard: React.FC<GovQuoteDashboardProps> = ({
  userRole,
  hideHeader = false
}) => {
  // Use existing dashboard components with government-specific props
  if (userRole === 'ENTERPRISE_VENDOR') {
    return (
      <VendorQuoteDashboard
        hideHeader={hideHeader}
      />
    )
  } else if (userRole === 'GOV_EMAIL') {
    // For government email users, show a simple message instead of making API calls
    return (
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
        {!hideHeader && (
          <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">
            Government Quote Dashboard
          </h2>
        )}
        <div className="text-center py-8">
          <p className="text-gray-600 dark:text-gray-400">
            Government quote management features are coming soon.
          </p>
        </div>
      </div>
    )
  } else {
    return (
      <BuyerQuoteDashboard
        hideHeader={hideHeader}
      />
    )
  }
}